'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import Link from 'next/link';
import { sendAnalyticsData, trackNavigation } from '@/src/utils/analytics';
import { AdvFeature } from './AdvFeature';
import { Frequentlyuseddocs } from './Freq-used-docs';
import { SchDistFAQs } from './SchDistFAQs';
import { Schooldistrictfeatures } from './Schooldistrictfeatures';

// const districtImage = [
//   {
//     imagePath: '/images/schooldistrict/district-2x.png',
//     imageWidth: 1024,
//     alt: 'Boost compliance with digital workflows',
//   },
// ];

function Heading() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-auto w-[min(400px,100%)] md:mx-0 lg:w-[92%]"><h1 className="text-[34px] font-medium !leading-tight text-[#3D3E40] md:mr-4 md:text-3xl xl:text-[54px]">IEP Goal Tracking for Your Special Ed Department</h1><p className="mb-2 mt-4 text-[17px] text-[#616366] md:mr-8 md:text-[18px] ">Ease the burden of paperwork on providers, and enhance compliance by leveraging the power of digital data</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function Demo() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      color: "#ffffff"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/request-quote" onClick={_temp} style={t0} className="mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] p-3 text-base font-medium md:py-2">Get a quote <ChevronRightIcon className="h-5 w-5" /></Link>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex xl:w-[70%]">{t1}<Link href="/schedule-demo" onClick={_temp2} style={{
        color: "#318AE5"
      }} className="mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium md:py-2">Schedule a Demo</Link></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-center justify-center md:items-start">{t2}<div className="mt-2 flex  text-[#616366] ">or<Link href="/contact-us" onClick={_temp3} style={{
          color: "#318ae5"
        }} className="mx-1 font-semibold">Contact us</Link>for more information.</div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp3() {
  sendAnalyticsData("CONTACT_US_BUTTON_CLICKED_FROM_SCHOOLANDDISTRICT");
  trackNavigation("contact-us", "Contact us");
}
function _temp2() {
  sendAnalyticsData("SCHEDULE_A_DEMO_BUTTON_CLICKED_FROM_SCHOOLANDDISTRICT");
  trackNavigation("schedule-demo", "Schedule a Demo");
}
function _temp() {
  sendAnalyticsData("GET_A_QUOTE_BUTTON_CLICKED_FROM_SCHOOLANDDISTRICT");
  trackNavigation("request-quote", "Get a quote");
}
function TextViews() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-y-4"><Heading /><Demo /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function Topportion() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="order-2 md:order-1"><TextViews /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="container  mx-auto mt-28 flex w-[90%] flex-col items-center justify-center overflow-hidden text-center md:flex-row  md:gap-x-4 md:p-6 md:px-0 md:py-4 md:text-left lg:justify-between lg:gap-x-0 lg:px-10 2xl:px-[10rem]">{t0}<div className="order-1 mb-4 ml-0 mt-0 w-[min(70%,300px)] md:order-2 md:mx-auto md:mb-0 md:w-[80%] md:px-0 lg:w-full lg:px-4"><Image src="/images/schooldistrict/district-2x.png" width={1024} height={1024} alt="Boost compliance with digital workflows" /></div></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function Compliant() {
  const $ = _c(6);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="mx-3 w-[30%] md:mx-0 md:w-[25%] lg:mx-3 lg:w-[15%] xl:mx-5 xl:w-[10%]"><Image src="/images/icons/compliant/Hippa/hippa-2x.png" width={1024} height={1024} alt="HIPAA" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="m-auto flex items-center justify-center">{t0}<div className="mx-3 w-[30%] md:mx-0 md:w-[25%] lg:mx-3 lg:w-[15%] xl:mx-5 xl:w-[10%]"><Image src="/images/icons/compliant/Ferpa/ferpa-2x.png" width={1024} height={1024} alt="FERPA" /></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mt-4 flex flex-col items-center justify-center text-center"><h3 className="mb-2 w-[70%] text-[28px] font-[500] text-[#3d3e40] md:text-[36px] ">Data Privacy You Can Count On</h3><p className="mb-4 w-[87%] text-[17px] text-[#616366] md:mx-60 md:text-[18px] xl:w-[58%]">AbleSpace prioritizes the privacy and security of student data and complies with various regulations, including HIPAA, FERPA, and statewide regulations like NYS Ed Law 2-D, ensuring that your sensitive information is always protected. Our platform is designed with multiple layers of security, including state-of-the-art encryption techniques, strict access controls, and regular audits and assessments to ensure that we are continuously meeting regulatory requirements.</p></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link href="/hipaa-ferpa-compliance" onClick={_temp4} style={{
      color: "#ffffff"
    }} className="mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] px-5 py-3 text-base font-medium md:py-2">Learn more...</Link>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      color: "#318AE5"
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div>{t1}{t2}<div className="mb-6 flex justify-center">{t3}<Link href="/request-quote" onClick={_temp5} style={t4} className="mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium md:py-2">Get a quote<ChevronRightIcon className="h-5 w-5" /></Link></div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}
function _temp5() {
  sendAnalyticsData("GET_A_QUOTE_BUTTON_CLICKED_FROM_SCHOOLANDDISTRICT");
  trackNavigation("request-quote", "Get a quote");
}
function _temp4() {
  return sendAnalyticsData("LEARN_MORE_BUTTON_CLICKED_FROM_SCHOOLANDDISTRICT");
}
export const Schoolanddistrict = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div><Topportion /><AdvFeature /><Compliant /><Schooldistrictfeatures /><Frequentlyuseddocs /><SchDistFAQs tag="schools/districts" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};